import { useEffect } from 'react';
import { useCiamStore } from '../../context';
import { CIAM_AUTHENTICATION_STATUS } from '../../types';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Authentication = _ref => {
  let {
    children,
    fallback,
    silent = false
  } = _ref;
  const authenticationStatus = useCiamStore(state => state.authenticationStatus);
  const getUserInfo = useCiamStore(state => state.getUserInfo);
  useEffect(() => {
    if (authenticationStatus === CIAM_AUTHENTICATION_STATUS.UNKNOWN) {
      getUserInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticationStatus]);
  if (silent || authenticationStatus === CIAM_AUTHENTICATION_STATUS.AUTHENTICATED || authenticationStatus === CIAM_AUTHENTICATION_STATUS.UNAUTHENTICATED) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (authenticationStatus === CIAM_AUTHENTICATION_STATUS.LOADING && fallback) {
    return fallback;
  }
  return null;
};
export default Authentication;